module.exports = __webpack_public_path__ + "img/elec_charge_fault.28f87563.png";